module.exports = __webpack_public_path__ + "static/F1_Image_01-063879f2eea34f65f03b2f3aa62a31e0.png";